export const STAGES = {
    request: {
        id: 'request',
        title: 'New Request',
        color: 'blue'
    },
    passed: {
        id: 'passed',
        title: 'Passed',
        color: 'default'
    },
    redacted: {
        id: 'redacted',
        title: 'Redacted',
        color: 'default'
    },
    ongoing: {
        id: 'ongoing',
        title: 'Ongoing',
        color: 'orange'
    },
    completed: {
        id: 'completed',
        title: 'Completed',
        color: 'cyan'
    },
    rework: {
        id: 'rework',
        title: 'Rework',
        color: 'volcano'
    },
    approved: {
        id: 'approved',
        title: 'Approved',
        color: 'green'
    },
    rejected: {
        id: 'rejected',
        title: 'Rejected',
        color: 'red'
    },
    all: {
        id: 'all',
        title: 'All',
        color: 'red'
    },
    sent_to_rework: {
        id: 'sent_to_rework',
        title: 'Sent To Rework',
        color: 'green'
    },
    hold: {
        id: 'hold',
        title: 'On Hold',
        color: 'magenta'
    },
    scrapped: {
        id: 'scrapped',
        title: 'Scrapped',
        color: 'magenta'
    },
    rework_request: {
        id: 'rework_request',
        title: 'Rework Request',
        color: 'magenta'
    }
};
export const CLIENT_STAGES = {
    approved: {
        id: 'approved',
        title: 'Approved',
        color: 'green'
    },
    finished: {
        id: 'finished',
        title: 'Finished',
        color: 'cyan'
    },
    in_progress: {
        id: 'in_progress',
        title: 'In Progress',
        color: 'orange'
    },
    new: {
        id: 'new',
        title: 'New',
        color: 'blue'
    },
    rejected: {
        id: 'rejected',
        title: 'Rejected',
        color: 'red'
    },
    hold: {
        id: 'hold',
        title: 'On Hold',
        color: 'magenta'
    },
    scrapped: {
        id: 'scrapped',
        title: 'Scrapped',
        color: 'magenta'
    },
    rework: {
        id: 'rework',
        title: 'In Progress',
        color: 'volcano'
    }
};
export const FEEDBACK_STAGE = {
    feedback: {
        id: 'feedback',
        title: 'Complete',
        color: 'cyan'
    },
    rework: {
        id: 'rework',
        title: 'Rework',
        color: 'volcano'
    }
};
//# sourceMappingURL=assignment_stage.js.map